import { useState } from "react";
import { useUser } from "../../contexts/UserContext";
import UserArea from "./UserArea";
import logoImage from "../../assets/HomePage/koala_logo_bright.png";

export default function Navbar() {
  const { user } = useUser();
  const isLoggedIn = !!user;

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-primary sticky top-0 z-50">
      <div className="max-w-screen-xl relative flex flex-wrap items-center justify-between mx-auto p-2">
        {/* === Left: Logo === */}
        <a href="/" className="flex items-center space-x-3 rtl:space-x-reverse">
          <img src={logoImage} className="h-12" alt="Logo" />
        </a>

        {/* === Center: Desktop Nav */}
        <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 md:order-1">
          <ul className="flex space-x-8 font-medium">
            <li className="flex flex-col justify-center"><a href="/map" className="custom-nav-item">Map</a></li>
            <li className="flex flex-col justify-center"><a href="/community" className="custom-nav-item">Community</a></li>
            <li className="flex flex-col justify-center"><a href="/#about-us" className="custom-nav-item">About Us</a></li>
          </ul>
        </div>

        {/* === Right: User Area + Mobile Toggle === */}
        <div className="flex items-center md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
          <UserArea isLoggedIn={isLoggedIn} />

          {/* Mobile menu toggle button */}
          <button
            onClick={() => setMobileMenuOpen((prev: boolean) => !prev)}
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-white rounded-lg md:hidden hover:bg-accent focus:outline-none focus:ring-2 focus:ring-accent"
            aria-controls="navbar-cta"
            aria-expanded={mobileMenuOpen}
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 17 14"
              xmlns="http://www.w3.org/2000/svg"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
        </div>

        {/* === Mobile Nav Menu === */}
        {mobileMenuOpen && (
          <div className="w-full mt-4 md:hidden" id="navbar-cta">
            <ul className="custom-nav-mobile">
              <li><a href="/map" className="custom-nav-item-mobile">Map</a></li>
              <li><a href="/community" className="custom-nav-item-mobile">Community</a></li>
              <li><a href="/#about-us" className="custom-nav-item-mobile">About Us</a></li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
}